import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dropdown, Input } from 'semantic-ui-react';

import { SavedSearches } from './SavedSearches';
import { SaveSearch } from './SaveSearch';

import {
  clearFiltersDependentOnCountry as clearFiltersDependentOnCountryAction,
  getFilteringOptions as getFilteringOptionsAction,
  performSearch as performSearchAction,
  setFilterValue as setFilterValueAction,
} from '../../store/filters/filters.actions';
import { getSavedSearches as getSavedSearchesAction } from '../../../../core/user/user.actions';
import { loadSavedSearch as loadSavedSearchAction } from '../../store/laboratoriesData/laboratoriesData.actions';

import { filtersSelector } from '../../store/filters/filters.selector';
import { userSelector } from '../../../../core/user/user.selector';
import { laboratoriesDataSelector } from '../../store/laboratoriesData/laboratoriesData.selector';

import { FILTERS } from '../../constants/filters.constants';

import { generateDropdownOptions } from '../../../../core/utils/core.utils';
import { MAIN_APP_CONTAINERS } from '../../../../core/constants/core.constants';

const SEARCH_INPUT_TEXT = {
  ACTION: 'Search',
  PLACEHOLDER: 'Laboratory name',
};

const SearchMenuComponent = ({
  searchValue,
  selectedYear,
  setFilterValue,
  selectedCountries,
  availableCountries,
  filteringOptions,
  savedSearches,
  areSavedSearchesLoading,
  pagination,
  performSearch,
  getSavedSearches,
  loadSavedSearch,
  filterValues,
}) => {
  const [searchTerm, setSearchTerm] = useState(searchValue);
  const { yearOptions } = filteringOptions;

  useEffect(() => {
    setSearchTerm(searchValue);
  }, [searchValue]);

  useEffect(() => {
    getSavedSearches(MAIN_APP_CONTAINERS.LABSCOPE);
  }, [getSavedSearches]);

  function onKeyUpHandler(e) {
    if (e.keyCode === 13) {
      performSearch({
        filterName: FILTERS.SEARCH,
        filterValue: searchTerm,
        shouldClearFilters: true,
      });
    }
  }

  function onYearChange(e, { value }) {
    const lastSelectedYear = filterValues[FILTERS.YEAR];
    const formattedYear = value.filter((year) => lastSelectedYear[lastSelectedYear.indexOf(year)] !== year);
    setFilterValue({ filterName: FILTERS.YEAR, filterValue: formattedYear });
    performSearch({ filterName: FILTERS.YEAR, filterValue: formattedYear });
  }

  function onCountryChange(e, { value }) {
    setFilterValue({ filterName: FILTERS.COUNTRIES, filterValue: value });
    performSearch({ filterName: FILTERS.COUNTRIES, filterValue: value });
  }

  return (
    <div className="search-block">
      <div className="filter-main">
        <div className="year-picker">
          <Dropdown
            text="Select year"
            options={generateDropdownOptions(yearOptions)}
            value={selectedYear}
            multiple
            closeOnChange
            onChange={onYearChange}
          />
        </div>
        <div className="year-picker">
          <Dropdown
            text="Select countries"
            options={generateDropdownOptions(availableCountries)}
            value={selectedCountries}
            multiple
            closeOnChange
            onChange={onCountryChange}
          />
        </div>
      </div>
      <div className="filter-secondary">
        <div className="search-input">
          <Input
            icon="search"
            iconPosition="left"
            className="hospitals-search"
            name="searchTerm"
            value={searchTerm}
            action={{
              content: SEARCH_INPUT_TEXT.ACTION,
              onClick: () => performSearch({
                filterName: FILTERS.SEARCH,
                filterValue: searchTerm,
                shouldClearFilters: true,
              }),
            }}
            placeholder={SEARCH_INPUT_TEXT.PLACEHOLDER}
            onChange={({ target: { value } }) => setSearchTerm(value)}
            onKeyUp={onKeyUpHandler}
          />
        </div>
        <div className="saved-searches-wrapper">
          <SaveSearch pagination={pagination} currentPageContext={MAIN_APP_CONTAINERS.LABSCOPE} />
          <SavedSearches
            savedSearches={savedSearches}
            areSavedSearchesLoading={areSavedSearchesLoading}
            currentPageContext={MAIN_APP_CONTAINERS.LABSCOPE}
            loadSavedSearch={loadSavedSearch}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  filteringOptions: filtersSelector.filteringOptions(state),
  filterValues: filtersSelector.filterValues(state),
  searchValue: filtersSelector.searchValue(state),
  selectedYear: filtersSelector.selectedYear(state),
  selectedCountries: filtersSelector.selectedCountries(state),
  availableCountries: filtersSelector.availableCountries(state),
  savedSearches: userSelector.savedSearches(state),
  areSavedSearchesLoading: userSelector.areSavedSearchesLoading(state),
  pagination: laboratoriesDataSelector.pagination(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  setFilterValue: setFilterValueAction,
  performSearch: performSearchAction,
  clearFiltersDependentOnCountry: clearFiltersDependentOnCountryAction,
  getFilteringOptions: getFilteringOptionsAction,
  getSavedSearches: getSavedSearchesAction,
  loadSavedSearch: loadSavedSearchAction,
}, dispatch);

export const SearchMenu = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SearchMenuComponent);
